import { message } from 'antd';
import load from 'load-script';
import { reqGetMaterialList, reqRemoveMaterial, refreshForm, getFileListForm, reqGetFrameList, submitLotteryForm, submitGameLotteryForm, welcomeMsgForm, setWelcomeMsgForm, updateForm,
  reqGetUserList, reqGetPaymentList, reqGetSurveyList, reqPostSurvey,
  reqGetUserSurveyList, reqSetUserSurveyEnabled, reqRemoveUserSurveyAns,
  reqAddUsersTag, reqRemoveUsersTag,
  submitWelcomeImage, submitWelcomeVideo, reqGetPushMsg, reqSetPushMsg, reqRemovePushMsg, reqSetupOnlineService,
  setProgressForm, submitUploadFile,
  reqQueryShowInfo,
  reqSetMontage, reqSetUserRole,
  reqGetCashMoneyPrompt, reqSetCashMoneyPrompt,
 } from '@/services/activityCustomer';
const Model = {
  namespace: 'activityCustomer',
  state: {
    imageList: null,
  	listData:null, //activitydata
    montageData: {},
    materialList: null,
    fileList: null,
    welcomeMsg: null,
    frameList: null,
    getUserList: null,
    userSurveyList: null,
    userPushMsg: null,
    userListDict: {},
    showInfo: {},
  },
  effects: {
    *submitAdvancedForm({ payload }, { call }) {
      yield call(fakeSubmitForm, payload);
      message.success('提交成功');
    },
    *setProgress({ payload, callback=()=>{} }, { call }) {
      console.log('model setProgress')
      // payload.date = moment(payload.date).startOf('day');
      yield call(setProgressForm, payload);
      callback();
      // message.success('抽獎活動已更新');
    },
    *submitGameLottery({ payload }, { call }) {
      console.log('model submitGameLottery', payload)
      yield call(submitGameLotteryForm, payload);
      message.success('抽獎活動已更新');
    },
    *submitLottery({ payload }, { call }) {
      console.log('model submitLottery')
      yield call(submitLotteryForm, payload);
      message.success('抽獎活動已更新');
    },
    *uploadWelcomeImage({ payload }, { call }) {
      console.log('model uploadWelcomeImage')
      const r = yield call(submitWelcomeImage, payload);
      if(payload.cb){
        payload.cb(r);
      }
    },
    *uploadFile({ payload }, { call }) {
      console.log('model uploadFile', payload)
      const r = yield call(submitUploadFile, payload);
      if(payload.cb){
        payload.cb(r);
      }
    },
    *uploadWelcomeVideo({ payload }, { call }) {
      console.log('model uploadWelcomeVideo')
      const r = yield call(submitWelcomeVideo, payload);
      if(payload.cb){
        payload.cb(r);
      }
    },
    *queryShowInfo({ payload, callback }, { call, put }) {
      console.log('model queryShowInfo')
      const r = yield call(reqQueryShowInfo, payload);
      yield put({
        type: 'updateShowInfo',
        payload: r,
      });
      if(callback){
        callback(r);
      }
    },
    *setUserRole({ payload }, { call }) {
      console.log('model setUserRole', payload)
      const r = yield call(reqSetUserRole, payload);
      if(payload.cb){
        payload.cb(r);
      }
    },
    *refresh({ payload }, { call, put }) {
      console.log('refresh', payload)
      // yield put({ type: 'reset'});
      // return
      const response = yield call(refreshForm, payload);
      yield put({
        type: 'update',
        payload: response,
      });
      // message.success('讀取成功');
    },

    *setupOnlineService({ payload, callback=()=>{} }, { call, put }) {
      console.log('activityCustomer/setupOnlineService', payload)
      const response = yield call(reqSetupOnlineService, payload);
      if(response!=''){
        load(`https://linein.01.firstline.cc/livechat.f8c0a3f7-27e6-408d-b00d-212d06fa4c4a.js?t=1616057669&once_code=${response}`);
      }
      console.log('activityCustomer/setupOnlineService done', response)
    },

    *submitUpdate({ payload, callback=()=>{} }, { call, put }) {
      console.log('activityCustomer/submitUpdate', payload)

      const response = yield call(updateForm, payload);
      message.success('儲存成功');
      callback()
    },

    *getFileList({ payload }, { call, put }) {
      console.log('model getFileList', payload)
      const response = yield call(getFileListForm, payload);
      yield put({
        type: 'reduceFileList',
        payload: response,
      });
      message.success('婚紗照讀取成功');
    },
    *getWelcomeMsg({ payload }, { call, put }) {
      console.log('model getWelcomeMsg', payload)

      const response = yield call(welcomeMsgForm, payload);
      yield put({
        type: 'reduceWelcomeMsg',
        payload: response,
      });
    },
    *setWelcomeMsg({ payload }, { call, put }) {
      console.log('model setWelcomeMsg', payload)
      const response = yield call(setWelcomeMsgForm, payload);
      yield put({
        type: 'reduceWelcomeMsg',
        payload: response,
      });
      // message.success('歡迎詞讀取成功');
    },

    *getUserList({ payload }, { call, put }) {
      // console.log('model getImageList', payload)
      const response = yield call(reqGetUserList, payload);
      yield put({
        type: 'reduceUserList',
        payload: response,
      });
      // message.success('婚紗照讀取成功');
    },
    *getPaymentList({ payload, callback }, { call, put }) {
      // console.log('model getImageList', payload)
      const response = yield call(reqGetPaymentList, payload);
      if(callback)( callback(response) );
    },

    *removeUserSurveyAns({ payload, callback }, { call, put }) {
      // console.log('model getImageList', payload)
      const response = yield call(reqRemoveUserSurveyAns, payload);
      yield put({
        type: 'getUserSurveyList',
        payload,
      });
      if(callback)( callback() );
      // message.success('婚紗照讀取成功');
    },

    *getUserSurveyList({ payload }, { call, put }) {
      // console.log('model getImageList', payload)
      const response = yield call(reqGetUserSurveyList, payload);
      yield put({
        type: 'reduceUserSurveyList',
        payload: response,
      });
      // message.success('婚紗照讀取成功');
    },

    *addUsersTag({ payload }, { call, put }) {
      // console.log('model getImageList', payload)
      const response = yield call(reqAddUsersTag, payload);
      yield put({
        type: 'getUserSurveyList',
        payload,
      });
      // message.success('婚紗照讀取成功');
    },

    *removeUsersTag({ payload }, { call, put }) {
      // console.log('model getImageList', payload)
      const response = yield call(reqRemoveUsersTag, payload);
      yield put({
        type: 'getUserSurveyList',
        payload,
      });
      // message.success('婚紗照讀取成功');
    },

    *setUserSurveyEnabled({ payload }, { call, put }) {
      console.log('setUserSurveyEnabled', payload.enabled)
      const response = yield call(reqSetUserSurveyEnabled, payload);
      yield put({
        type: 'reduceUserSurveyEnabled',
        payload: response,
      });
    },

    *removePushMsg({ payload }, { call, put }) {
      // console.log('model getImageList', payload)
      const response = yield call(reqRemovePushMsg, payload);
      if(response.success){
        message.success('取消預約成功');
      }else{
        message.warning('取消預約失敗:'+response.msg);
      }
      yield put({ type: 'activityCustomer/getPushMsg', payload });
    },

    *setMontage({ payload, callback }, { call, put }) {
      console.log('model setMontage', payload)
      const response = yield call(reqSetMontage, payload);
      if(callback){ callback(response)};
      yield put({ type: 'activityCustomer/reduceMontage', payload: response.montage });
      console.log('put reduceMontage');
    },

    *getPushMsg({ payload }, { call, put }) {
      // console.log('model getImageList', payload)
      const response = yield call(reqGetPushMsg, payload);
      yield put({
        type: 'reduceUserPushMsg',
        payload: response,
      });
    },

    *setPushMsg({ payload, callback }, { call, put }) {
      // console.log('model getImageList', payload)
      const response = yield call(reqSetPushMsg, payload);
      callback(response)
      yield put({ type: 'activityCustomer/getPushMsg', payload });
      console.log('put getPushMsg again')
    },

    *getSurveyList({ payload, callback }, { call, put }) {
      // console.log('model getImageList', payload)
      const response = yield call(reqGetSurveyList, payload);
      yield put({
        type: 'reduceSurveyList',
        payload: response,
      });
      callback(response)
      // message.success('婚紗照讀取成功');
    },

    *postSurvey({ payload, callback }, { call, put }) {
      console.log('model postSurvey', payload)
      const response = yield call(reqPostSurvey, payload);
      yield put({
        type: 'reduceSurveyList',
        payload: response,
      });
      callback(response)
    },

    *setCashMoneyPrompt({ payload, callback }, { call, put }) {
      console.log('model setCashMoneyPrompt', payload)
      const response = yield call(reqSetCashMoneyPrompt, payload);
      // yield put({
      //   type: 'reduceSurveyList',
      //   payload: response,
      // });
      callback(response)
    },
    *getCashMoneyPrompt({ payload, callback }, { call, put }) {
      console.log('model getCashMoneyPrompt', payload)
      const response = yield call(reqGetCashMoneyPrompt, payload);
      // yield put({
      //   type: 'reduceSurveyList',
      //   payload: response,
      // });
      // console.log('getCashMoneyPrompt', response.prompt)
      callback(response.prompt)
    },
/*
    *clearImageList({ payload, callback }, { call, put }) {
      // console.log('model getImageList', payload)
      const response = yield call(reqClearImageList, payload);
      if(callback){
        callback(response);
      }
    },

    *getImageList({ payload }, { call, put }) {
      // console.log('model getImageList', payload)
      const response = yield call(reqGetImageList, payload);
      yield put({
        type: 'reduceImageList',
        payload: response,
      });
      // message.success('婚紗照讀取成功');
    },
    *removeImage({ payload }, { call, put }) {
      // console.log('model removeImage', payload)
      const response = yield call(reqRemoveImage, payload);
      // message.success('婚紗照讀取成功');
    },
*/
    *getMaterialList({ payload }, { call, put }) {
      // console.log('model getImageList', payload)
      const response = yield call(reqGetMaterialList, payload);
      yield put({
        type: 'reduceMaterialList',
        payload: response,
      });
      // message.success('婚紗照讀取成功');
    },
    *removeMaterial({ payload }, { call, put }) {
      // console.log('model removeImage', payload)
      const response = yield call(reqRemoveMaterial, payload);
      // message.success('婚紗照讀取成功');
    },
    *getFrameList({ payload }, { call, put }) {
      // console.log('model getImageList', payload)
      const response = yield call(reqGetFrameList, payload);
      yield put({
        type: 'reduceFrameList',
        payload: response,
      });
      // message.success('婚紗照讀取成功');
    },
  },
  reducers: {
    reset(state) {
      return {
        imageList: null,
        montageData: {},
        listData:null,
        fileList: null,
        materialList: [],
        welcomeMsg: null,
      }
    },
    updateShowInfo(state, action) {
      console.log('updateShowInfo', action.payload);
      return { ...state, showInfo: {loaded:true, ...action.payload}};
    },
    update(state, action) {
      // console.log('update', action.payload.activity)
      return { ...state, listData: action.payload.activity};
    },
    // reduceWelcomeMsg(state, {payload: {welcomeMsg}}) {
    reduceWelcomeMsg(state, {payload}) {
      console.log('reduceWelcomeMsg', payload)

      return { ...state, welcomeMsg: payload.length>0 ? payload[0].text : ''};
    },
    reduceMontage(state, action) {
      console.log('save reducers montage', action.payload)
      return { ...state, montageData: action.payload };
    },
    reduceFileList(state, action) {
      console.log('save reducers', action.payload)
      return { ...state, fileList: action.payload };
    },
    /*
    reduceImageList(state, action) {
      console.log('reduceImageList', action)
      return { ...state, imageList: action.payload || null};
    },
    */
    reduceMaterialList(state, action) {
      return { ...state, materialList: action.payload || null};
    },
    reduceUserList(state, action) {
      const userListDict = {};
      (action.payload || []).forEach(e=>{
        userListDict[e.userid] = e;
      })
      return { ...state, userList: action.payload || null, userListDict};
    },
    reduceUserSurveyList(state, action) {
      const qs_map = (action.payload.qs || []).filter(({choices})=>choices && choices.length>0).reduce((acc, cur)=>{
        acc[cur.name] = cur.choices.reduce((acc2, cur2)=>{
          acc2[cur2.value] = cur2.text;
          return acc2;
        }, {});
        return acc;
      }, {});
      return { ...state, userSurveyList: {qs_map, ...action.payload} || null};
    },
    reduceUserSurveyEnabled(state, action) {
      return { ...state, userSurveyList: {...state.userSurveyList, enabled: action.payload.enabled}};
    },
    reduceUserPushMsg(state, action) {
      return { ...state, userPushMsg: action.payload || null};
    },
    reduceFrameList(state, action) {
      console.log('reduceFrameList', action)
      return { ...state, frameList: action.payload || null};
    },
  },
};
export default Model;
